<template>
  <div class="resource_subject_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
    </div>
    <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="resource_subject_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="年级" prop="gradeId">
            <el-select v-model="formData.gradeId" placeholder="请选择年级" size="medium">
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item" :value="index+1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上下册" prop="term">
            <el-select v-model="formData.term" placeholder="请选择" size="medium">
              <el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in termList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面" prop="bookPic">
            <uploader pathPrefix="resourceSubject" :extList="['png', 'jpg', 'jpeg']" showResult="image" showMode="cover" v-model="bookPic" :multiple="false"></uploader>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="formData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import Uploader from "@/components/Uploader/WebUploader";
  import {getGradeLevelListByAtlasId, addGradeAtlas} from '@/api/resourceMap'

  export default {
    name: "resourceSubjectAdd",
    components: {Uploader},
    data() {
      return {
        atlasId: this.$route.query.atlasId,
        gradeList: [],
        termList: [{value: 1, label: '上册'},{value: 2, label: '下册'}],
        bookPic: [],
        formData: {
          gradeId: 1,
          term: 1,
          remark: ''
        },
        rules: {
          gradeId: [
            {required: true, trigger: 'blur', message: '请选择年级'}
          ],
          term: [
            {required: true, trigger: 'blur', message: '请选择上下册'}
          ]
        }
      }
    },
    mixins: [windowResize],
    created() {
      this.getGradeLevelListByAtlasId();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getGradeLevelListByAtlasId() {
        getGradeLevelListByAtlasId({atlasId: this.atlasId}).then(data => {
          this.gradeList = data;
        })
      },
      saveSuite() {
        this.$refs.form.validate(isValid => {
          if (isValid) {
            new Promise(resolve => {
              let query = {
                atlasId: this.atlasId,
                gradeLevel: this.formData.gradeId,
                imgUrl: this.bookPic.length ? this.bookPic[0].fileUrl : '',
                level: 1,
                name: this.getGradeLevelName() + this.termList[this.formData.term - 1].label,
                orderNo: this.formData.gradeId,
                remark: this.formData.remark,
                term: this.formData.term,
                type: 1
              };
              addGradeAtlas(query).then(resolve)
            }).then(() => {
              this.$message.success(`新增成功`);
              window.setTimeout(() => {
                this.goBack();
              }, 500);
            })
          }
        })
      },
      getGradeLevelName() {
        let levelName = '';
        this.gradeList.forEach((item, index) => {
          if (this.formData.gradeId - 1 === index) {
            levelName = item;
          }
        });
        return levelName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_subject_add_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .resource_subject_box {
      @include scrollBar;

      .resource_subject_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceSubjectAdd.vue